export default __webpack_public_path__ + "0f732b622c2a2a256940ec159c5a7941.png";